<template>
  <mdb-container class="mt-5">
    <mdb-card>
      <mdb-card-title class="mt-4 h2">Contact us</mdb-card-title>
      <mdb-card-body>
        <mdb-card-text class="pr-5 pl-5" mr-4 ml-4
          >Do you have any questions? Please do not hesitate to contact us
          directly. Our team will cgetback to you within a matter of hours to
          help you.</mdb-card-text
        >
        <form class="needs-validation" validate @submit.prevent="submitForm">
          <mdb-row>
            <mdb-col md="12">
              <mdb-row>
                <mdb-col>
                  <mdb-input label="Your name" v-model="fields.name" required />
                  <mdb-input
                    label="Your address (optional)"
                    v-model="fields.address"
                  />
                </mdb-col>

                <mdb-col>
                  <mdb-input
                    type="email"
                    label="Your email"
                    v-model="fields.email"
                    optional
                  />
                  <mdb-input
                    type="phone"
                    label="Your Phone #"
                    v-model="fields.phone"
                    optional
                  />
                </mdb-col>
              </mdb-row>
              <mdb-row>
                <mdb-col>
                  <mdb-input
                    label="Subject"
                    v-model="fields.subject"
                    required
                  />
                </mdb-col>
              </mdb-row>
              <mdb-row>
                <mdb-col>
                  <mdb-input
                    type="textarea"
                    label="Your message"
                    v-model="fields.message"
                    required
                  />
                </mdb-col>
              </mdb-row>
            </mdb-col>
          </mdb-row>
          <mdb-btn color="primary" type="submit" class="float-left"
            >Send</mdb-btn
          >
        </form>
      </mdb-card-body>
    </mdb-card>
  </mdb-container>
</template>

<script>
import {
  mdbContainer,
  mdbInput,
  mdbCard,
  mdbCardTitle,
  mdbCardText,
  mdbCardBody,
  mdbBtn,
  mdbRow,
  mdbCol,
} from "mdbvue";

export default {
  components: {
    mdbContainer,
    mdbInput,
    mdbCard,

    mdbCardTitle,
    mdbCardBody,
    mdbCardText,
    mdbBtn,
    mdbRow,
    mdbCol,
  },
  data() {
    return {
      fields: {
        name: "",
        address: "",
        phone: "",
        email: "",
        subject: "",
        message: "",
      },
    };
  },
  methods: {
    submitForm(event) {
      if (this.fields.address != "") {
        event.target.classList.add("was-validated");
      } else {
        this.fields[1].invalidFeedback =
          "Password should contain at least one uppercase character.";
      }
      // submit form
    },
  },
};
</script>